// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%275%27 viewBox=%270 0 8 4%27%3E%3Cpath d=%27M4 4L0.535899 0.25L7.4641 0.25L4 4Z%27 fill=%27%23102C98%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InsufficiencyDetails {
  width: 100%;
  height: 100%;
  padding: 0.75rem 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  align-items: center;
  overflow: auto;
  position: relative;
}
.InsufficiencyDetails .Header {
  width: 100%;
  padding-bottom: 0.5rem;
  border-bottom: 0.0625rem solid var(--Stroke);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.25rem;
}
.InsufficiencyDetails .Header .Tabs {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.InsufficiencyDetails .Header .Tabs button {
  padding: 0.375rem 0.5rem 0.375rem 0.5rem;
  background: var(--Foreground);
  border: 0.0625rem solid var(--Stroke);
  color: var(--TextColor);
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}
.InsufficiencyDetails .Header .Tabs button span {
  font-size: 0.875rem;
  line-height: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.InsufficiencyDetails .Header .Tabs button span:nth-child(2) {
  font-size: 0.75rem;
  min-height: 1.25rem;
  min-width: 1.25rem;
  padding: 0.125rem 0.25rem;
  background: var(--Pending);
  border-radius: 0.125rem;
  align-content: center;
}
.InsufficiencyDetails .Header .Tabs .Active {
  background: var(--Invitation);
  transition: all 0.3s ease;
}
.InsufficiencyDetails .Header .Tabs .Active span:nth-child(2) {
  background: var(--Pending);
}
.InsufficiencyDetails .Header .FilterContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
}
.InsufficiencyDetails .Header .FilterContainer select {
  padding: 0.375rem 0.5rem 0.375rem 0.5rem;
  min-width: 7.5rem;
  background: var(--Foreground);
  color: var(--TextColor);
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}
.InsufficiencyDetails .ContentContainer {
  flex: 1 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: auto;
  position: relative;
}
.InsufficiencyDetails .ContentContainer .Content {
  flex: 1 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.InsufficiencyDetails .ContentContainer .Content article {
  padding: 0.5rem 0.75rem;
  background: var(--Foreground);
  border-radius: 0.5rem;
  cursor: pointer;
}
.InsufficiencyDetails .ContentContainer .Content article .CandidateDetails {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
}
.InsufficiencyDetails .ContentContainer .Content article .CandidateDetails .Name {
  font-size: 0.875rem;
  width: 13rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--TextColor);
}
.InsufficiencyDetails .ContentContainer .Content article .CandidateDetails .Details {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9.375rem, 1fr));
  gap: 0.75rem;
}
.InsufficiencyDetails .ContentContainer .Content article .CandidateDetails .Details .LabelValue {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.InsufficiencyDetails .ContentContainer .Content article .CandidateDetails .Details .LabelValue .Label {
  font-size: 0.625rem;
  color: #9b9b9b;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.InsufficiencyDetails .ContentContainer .Content article .CandidateDetails .Details .LabelValue .Value {
  font-size: 0.75rem;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.InsufficiencyDetails .ContentContainer .Content article .CandidateDetails .InsuffCount {
  padding: 0.25rem 0.5rem;
  width: 3.25rem;
  background: var(--Invitation);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: var(--AccentColor);
  border-radius: 0.375rem;
  cursor: pointer;
}
.InsufficiencyDetails .ContentContainer .Content article .CandidateDetails .InsuffCount svg {
  min-width: 1rem;
}
.InsufficiencyDetails .ContentContainer .Content article .CandidateDetails .InsuffCount svg path {
  fill: var(--AccentColor);
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: all 0.3s ease;
  overflow: hidden;
  cursor: default;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper {
  width: 100%;
  overflow: hidden;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail {
  display: flex;
  width: 100%;
  margin-top: 0.75rem;
  padding: 0.375rem 0;
  border-top: 0.0625rem solid var(--Invitation);
  overflow: hidden;
  flex-direction: column;
  gap: 0.75rem;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail h3 {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--AccentColor);
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.25rem;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .Institution {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  padding-bottom: 0.5rem;
  border-bottom: 0.0625rem solid var(--Stroke);
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .Institution .InsDetail {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .Institution .InsDetail svg {
  min-width: 1.5rem;
  min-height: 1.5rem;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .Institution .InsDetail svg path {
  fill: var(--TextColor);
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .Institution .InsDetail .LabelValue {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 12.5rem;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .Institution .InsDetail .LabelValue .Label {
  max-width: 12.5rem;
  font-size: 0.625rem;
  color: var(--TextColor);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .Institution .InsDetail .LabelValue .Value {
  max-width: 12.5rem;
  font-size: 0.75rem;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton {
  padding: 0 0.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton .Comment {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  width: 70%;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton .Comment .Label {
  font-size: 0.625rem;
  font-weight: 500;
  color: var(--TextColor);
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton .Comment .Value {
  font-size: 0.75rem;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton .TimeButton {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton .TimeButton span {
  color: #9b9b9b;
  font-size: 0.625rem;
  font-weight: 500;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton .TimeButton button {
  width: 9rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  border: none;
  background: var(--Invitation);
  font-size: 0.75rem;
  color: var(--TextColor);
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton .TimeButton .insufficiency {
  cursor: pointer;
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton .TimeButton .rejected {
  background: var(--Cancelled);
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton .TimeButton .awaiting_approval {
  background: var(--Pending);
}
.InsufficiencyDetails .ContentContainer .Content article .ExpandedDetailWrapper .Wrapper .ExpandDetail .InsuffDetail .CommentSection .CommentButton .TimeButton .fullfillment {
  background: var(--AccentColor);
  color: #ffffff;
}
.InsufficiencyDetails .ContentContainer .Content article .Show {
  grid-template-rows: 1fr;
  transition: all 0.3s ease;
}
.InsufficiencyDetails .ContentContainer .Content article:hover {
  background: var(--Hover);
}
.InsufficiencyDetails .ContentContainer .PaginationContainer {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .Pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  gap: 5px;
  padding-right: 1.25rem;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .Pagination .NextPrev {
  color: #363854;
  background: none;
  border: none;
  font-weight: 700;
  padding: 5px 0.625rem;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .Pagination .NextPrev:hover {
  border-radius: 25px;
  background: #efefef;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .Pagination .PageNo {
  width: 25px;
  height: 25px;
  color: #363854;
  border-radius: 1.25rem;
  padding: 5px;
  background: none;
  border: none;
  font-weight: 700;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .Pagination .PageNo:hover {
  background: #efefef;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .Pagination .CurrentPage {
  background: #efefef;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .Pagination .disabled {
  color: #8a8a8a;
  cursor: not-allowed;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .ItemsPerPage {
  width: 100px;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 0.0625rem solid #102c98;
  border-radius: 0.5rem;
  padding-right: 5px;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .ItemsPerPage .OptionsLabel {
  color: #363854;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0px 0.625rem;
  border-right: 0.0625rem solid #102c98;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .ItemsPerPage .Options {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right center;
  background-size: 0.875rem;
  width: 45px;
  height: 1.25rem;
  border: none;
  font-size: 0.75rem;
  color: #363854;
  outline: none;
}
.InsufficiencyDetails .ContentContainer .PaginationContainer .ItemsPerPage .Options option {
  background-color: #fff;
  color: #363854;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/Insufficiency/InsufficiencyDetails.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AACJ;AAAI;EACE,WAAA;EACA,sBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;AAEN;AADM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAGR;AAFQ;EACE,wCAAA;EACA,6BAAA;EACA,qCAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AAIV;AAHU;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAKZ;AAHU;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,uBAAA;EACA,qBAAA;AAKZ;AAFQ;EACE,6BAAA;EACA,yBAAA;AAIV;AAHU;EACE,0BAAA;AAKZ;AADM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AAGR;AAFQ;EACE,wCAAA;EACA,iBAAA;EACA,6BAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AAIV;AAAI;EACE,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AAEN;AADM;EACE,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAGR;AAFQ;EACE,uBAAA;EACA,6BAAA;EACA,qBAAA;EACA,eAAA;AAIV;AAHU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAKZ;AAJY;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;AAMd;AAJY;EACE,SAAA;EACA,aAAA;EACA,8DAAA;EACA,YAAA;AAMd;AALc;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAOhB;AANgB;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAQlB;AANgB;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAQlB;AAJY;EACE,uBAAA;EACA,cAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;AAMd;AALc;EACE,eAAA;AAOhB;AANgB;EACE,wBAAA;AAQlB;AAHU;EACE,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AAKZ;AAJY;EACE,WAAA;EACA,gBAAA;AAMd;AALc;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;AAOhB;AANgB;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;AAQlB;AANgB;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qCAAA;EACA,sBAAA;AAQlB;AAPkB;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,4CAAA;AASpB;AARoB;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAUtB;AATsB;EACE,iBAAA;EACA,kBAAA;AAWxB;AAVwB;EACE,sBAAA;AAY1B;AATsB;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AAWxB;AAVwB;EACE,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAY1B;AAVwB;EACE,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAY1B;AAPkB;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AASpB;AARoB;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAUtB;AATsB;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AAWxB;AAVwB;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAY1B;AAVwB;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAY1B;AATsB;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;AAWxB;AAVwB;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AAY1B;AAVwB;EACE,WAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;AAY1B;AAVwB;EACE,eAAA;AAY1B;AAVwB;EACE,4BAAA;AAY1B;AAVwB;EACE,0BAAA;AAY1B;AAVwB;EACE,8BAAA;EACA,cAAA;AAY1B;AAHU;EACE,uBAAA;EACA,yBAAA;AAKZ;AAFQ;EACE,wBAAA;AAIV;AADM;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAGR;AAFQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;EACA,sBAAA;AAIV;AAHU;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAKZ;AAHU;EACE,mBAAA;EACA,mBAAA;AAKZ;AAHU;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAKZ;AAHU;EACE,mBAAA;AAKZ;AAHU;EACE,mBAAA;AAKZ;AAHU;EACE,cAAA;EACA,mBAAA;AAKZ;AAFQ;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;AAIV;AAHU;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qCAAA;AAKZ;AAHU;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,0EAAA;EAEA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AAIZ;AAHY;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;AAKd","sourcesContent":[".InsufficiencyDetails {\n    width: 100%;\n    height: 100%;\n    padding: 0.75rem 0 0 0;\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n    align-items: center;\n    overflow: auto;\n    position: relative;\n    .Header {\n      width: 100%;\n      padding-bottom: 0.5rem;\n      border-bottom: 0.0625rem solid var(--Stroke);\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      flex-wrap: wrap;\n      gap: 1.25rem;\n      .Tabs {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 0.75rem;\n        button {\n          padding: 0.375rem 0.5rem 0.375rem 0.5rem;\n          background: var(--Foreground);\n          border: 0.0625rem solid var(--Stroke);\n          color: var(--TextColor);\n          border-radius: 0.25rem;\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n          cursor: pointer;\n          transition: all 0.3s ease;\n          span {\n            font-size: 0.875rem;\n            line-height: 1rem;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n          span:nth-child(2) {\n            font-size: 0.75rem;\n            min-height: 1.25rem;\n            min-width: 1.25rem;\n            padding: 0.125rem 0.25rem;\n            background: var(--Pending);\n            border-radius: 0.125rem;\n            align-content: center;\n          }\n        }\n        .Active {\n          background: var(--Invitation);\n          transition: all 0.3s ease;\n          span:nth-child(2) {\n            background: var(--Pending);\n          }\n        }\n      }\n      .FilterContainer {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 0.75rem;\n        select {\n          padding: 0.375rem 0.5rem 0.375rem 0.5rem;\n          min-width: 7.5rem;\n          background: var(--Foreground);\n          color: var(--TextColor);\n          border: none;\n          border-radius: 0.25rem;\n          font-size: 0.875rem;\n        }\n      }\n    }\n    .ContentContainer {\n      flex: 1;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 0.75rem;\n      overflow: auto;\n      position: relative;\n      .Content {\n        flex: 1;\n        overflow: auto;\n        display: flex;\n        flex-direction: column;\n        gap: 0.75rem;\n        article {\n          padding: 0.5rem 0.75rem;\n          background: var(--Foreground);\n          border-radius: 0.5rem;\n          cursor: pointer;\n          .CandidateDetails {\n            width: 100%;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            gap: 1.25rem;\n            .Name {\n              font-size: 0.875rem;\n              width: 13rem;\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n              color: var(--TextColor);\n            }\n            .Details {\n              flex: 1;\n              display: grid;\n              grid-template-columns: repeat(auto-fit, minmax(9.375rem, 1fr));\n              gap: 0.75rem;\n              .LabelValue {\n                display: flex;\n                flex-direction: column;\n                align-items: flex-start;\n                .Label {\n                  font-size: 0.625rem;\n                  color: #9b9b9b;\n                  font-weight: 500;\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                }\n                .Value {\n                  font-size: 0.75rem;\n                  color: var(--TextColor);\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                }\n              }\n            }\n            .InsuffCount {\n              padding: 0.25rem 0.5rem;\n              width: 3.25rem;\n              background: var(--Invitation);\n              display: flex;\n              align-items: center;\n              gap: 0.5rem;\n              font-size: 0.75rem;\n              color: var(--AccentColor);\n              border-radius: 0.375rem;\n              cursor: pointer;\n              svg{\n                min-width: 1rem;\n                path{\n                  fill: var(--AccentColor);\n                }\n              }\n            }\n          }\n          .ExpandedDetailWrapper {\n            display: grid;\n            grid-template-rows: 0fr;\n            transition: all 0.3s ease;\n            overflow: hidden;\n            cursor: default;\n            .Wrapper {\n              width: 100%;\n              overflow: hidden;\n              .ExpandDetail {\n                display: flex;\n                width: 100%;\n                margin-top: 0.75rem;\n                padding: 0.375rem 0;\n                border-top: 0.0625rem solid var(--Invitation);\n                overflow: hidden;\n                flex-direction: column;\n                gap: 0.75rem;\n                h3 {\n                  font-size: 0.875rem;\n                  font-weight: 700;\n                  color: var(--AccentColor);\n                }\n                .InsuffDetail {\n                  padding: 0.5rem;\n                  display: flex;\n                  flex-direction: column;\n                  gap: 0.5rem;\n                  border: 0.0625rem solid var(--Stroke);\n                  border-radius: 0.25rem;\n                  .Institution {\n                    display: flex;\n                    flex-direction: row;\n                    align-items: center;\n                    gap: 2rem;\n                    padding-bottom: 0.5rem;\n                    border-bottom: 0.0625rem solid var(--Stroke);\n                    .InsDetail {\n                      display: flex;\n                      flex-direction: row;\n                      align-items: center;\n                      gap: 0.25rem;\n                      svg {\n                        min-width: 1.5rem;\n                        min-height: 1.5rem;\n                        path{\n                          fill: var(--TextColor);\n                        }\n                      }\n                      .LabelValue {\n                        display: flex;\n                        flex-direction: column;\n                        align-items: flex-start;\n                        max-width: 12.5rem;\n                        .Label {\n                          max-width: 12.5rem;\n                          font-size: 0.625rem;\n                          color: var(--TextColor);\n                          font-weight: 500;\n                          white-space: nowrap;\n                          overflow: hidden;\n                          text-overflow: ellipsis;\n                        }\n                        .Value {\n                          max-width: 12.5rem;\n                          font-size: 0.75rem;\n                          color: var(--TextColor);\n                          white-space: nowrap;\n                          overflow: hidden;\n                          text-overflow: ellipsis;\n                        }\n                      }\n                    }\n                  }\n                  .CommentSection {\n                    display: flex;\n                    flex-direction: column;\n                    gap: 0.75rem;\n                    .CommentButton {\n                      padding: 0 0.75rem;\n                      display: flex;\n                      flex-direction: row;\n                      align-items: center;\n                      .Comment {\n                        flex: 1;\n                        display: flex;\n                        flex-direction: column;\n                        width: 70%;\n                        .Label {\n                          font-size: 0.625rem;\n                          font-weight: 500;\n                          color: var(--TextColor);\n                        }\n                        .Value {\n                          font-size: 0.75rem;\n                          color: var(--TextColor);\n                          white-space: nowrap;\n                          overflow: hidden;\n                          text-overflow: ellipsis;\n                        }\n                      }\n                      .TimeButton {\n                        display: flex;\n                        flex-direction: column;\n                        align-items: flex-end;\n                        gap: 0.25rem;\n                        span {\n                          color: #9b9b9b;\n                          font-size: 0.625rem;\n                          font-weight: 500;\n                        }\n                        button {\n                          width: 9rem;\n                          height: 1.5rem;\n                          border-radius: 0.25rem;\n                          border: none;\n                          background: var(--Invitation);\n                          font-size: 0.75rem;\n                          color: var(--TextColor);\n                        }\n                        .insufficiency {\n                          cursor: pointer;\n                        }\n                        .rejected {\n                          background: var(--Cancelled);\n                        }\n                        .awaiting_approval {\n                          background: var(--Pending);\n                        }\n                        .fullfillment {\n                          background: var(--AccentColor);\n                          color: #ffffff;\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          .Show {\n            grid-template-rows: 1fr;\n            transition: all 0.3s ease;\n          }\n        }\n        article:hover{\n          background: var(--Hover);\n        }\n      }\n      .PaginationContainer {\n        height: 50px;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        .Pagination {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          height: 100%;\n          gap: 5px;\n          padding-right: 1.25rem;\n          .NextPrev {\n            color: #363854;\n            background: none;\n            border: none;\n            font-weight: 700;\n            padding: 5px 0.625rem;\n          }\n          .NextPrev:hover {\n            border-radius: 25px;\n            background: #efefef;\n          }\n          .PageNo {\n            width: 25px;\n            height: 25px;\n            color: #363854;\n            border-radius: 1.25rem;\n            padding: 5px;\n            background: none;\n            border: none;\n            font-weight: 700;\n          }\n          .PageNo:hover {\n            background: #efefef;\n          }\n          .CurrentPage {\n            background: #efefef;\n          }\n          .disabled {\n            color: #8a8a8a;\n            cursor: not-allowed;\n          }\n        }\n        .ItemsPerPage {\n          width: 100px;\n          height: 30px;\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          border: 0.0625rem solid #102c98;\n          border-radius: 0.5rem;\n          padding-right: 5px;\n          .OptionsLabel {\n            color: #363854;\n            font-size: 0.75rem;\n            font-weight: 500;\n            padding: 0px 0.625rem;\n            border-right: 0.0625rem solid #102c98;\n          }\n          .Options {\n            appearance: none;\n            -webkit-appearance: none;\n            -moz-appearance: none;\n            background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='5' viewBox='0 0 8 4'%3E%3Cpath d='M4 4L0.535899 0.25L7.4641 0.25L4 4Z' fill='%23102C98'/%3E%3C/svg%3E\")\n              no-repeat right center;\n            background-size: 0.875rem;\n            width: 45px;\n            height: 1.25rem;\n            border: none;\n            font-size: 0.75rem;\n            color: #363854;\n            outline: none;\n            option {\n              background-color: #fff;\n              color: #363854;\n              text-align: center;\n            }\n          }\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
